import { ForwardedRef, forwardRef, ReactNode } from "react"
import { useCurrentPage } from "../hooks/useCurrentPage"
import { PopoverButton } from "./PopoverButton"
import { Color, Expr } from "../../shared/Expr"
import TextField from "@mui/material/TextField"

type Props<T extends HTMLElement> = {
  children: (
    clickHandler: (event: React.MouseEvent<T>) => void,
    ref: ForwardedRef<HTMLButtonElement>,
    color: Expr<number>,
  ) => ReactNode
  number: Expr<number>
  onChange: (number: Expr<number>) => void
  noParams?: boolean
}

export const NumberPickerButton = forwardRef<
  HTMLButtonElement,
  Props<HTMLButtonElement>
>(function NumberPickerButton({ number, onChange, children, noParams }, ref) {
  const page = useCurrentPage()

  console.log({ number })

  const numberParameters = Object.entries(page.meta.parameters ?? {}).filter(
    ([_, p]) => p.type === "number",
  )

  const parameterValues = page.meta.parameterValues

  return (
    <PopoverButton
      ref={ref}
      renderButton={(clickHandler, ref) => children(clickHandler, ref, number)}
    >
      {() => (
        <>
          <TextField
            type="number"
            value={number.type === "lit" ? number.value : undefined}
            onChange={(ev: any) =>
              onChange(Expr.lit(Number(ev.currentTarget.value)))
            }
          />
          <div
            style={{
              display: "flex",
              gap: 4,
              flexDirection: "column",
              padding: 4,
            }}
          >
            {!noParams &&
              numberParameters.map(([id, p]) => (
                <div key={id}>
                  <button
                    style={{
                      display: "flex",
                      padding: "4px 8px",
                      gap: 4,
                      borderRadius: 99,
                      border: "1px solid #ddd",
                      alignItems: "center",
                    }}
                    onClick={() => onChange(Expr.ref(id))}
                  >
                    <span
                      style={{
                        opacity:
                          number.type === "ref" && number.id === id ? 1 : 0,
                      }}
                    >
                      ✔
                    </span>
                    <div
                      style={{
                        borderRadius: 2,
                        width: 30,
                        height: 18,
                      }}
                    >
                      {Expr.evaluate(parameterValues[id], {})}
                    </div>
                    {p.name}
                  </button>
                </div>
              ))}
          </div>
        </>
      )}
    </PopoverButton>
  )
})
